import { Stack, Text, StackProps } from "@chakra-ui/react";
import { FC } from "react";

type LabelProps = StackProps & {
  message: string;
  bgColor?: string;
  textVarinant?: string;
};

const Label: FC<LabelProps> = ({
  bgColor = "ud-yellow-300",
  message,
  textVarinant = "small_1",
  ...props
}) => (
  <Stack
    backgroundColor={bgColor}
    borderRadius="4px"
    p="5px 6px 3px"
    h="fit-content"
    textTransform="uppercase"
    {...props}
  >
    <Text variant={textVarinant} fontWeight="bold">
      {message}
    </Text>
  </Stack>
);

export default Label;
